import { useNavigate } from 'react-router-dom';
import { useOverlayContext } from 'seagull';
import { Copy, Edit, Eye, Trash } from 'seagull/icons';
import { useStore } from '~/contexts';
import { useContactsMap } from '~/hooks/reactQuery/derived/useContactsMap';
import { useDuplicateDraft } from '~/hooks/reactQuery/mutations/useDuplicateDraft';
import { usePreviewDraft } from '~/hooks/usePreviewDraft';
import { useTerminateAgreement } from '~/hooks/useTerminateAgreement';
import { useLocaleKeys } from '~/i18n';
import { selectors } from '~/store/state-selectors';
import { useArchivedProposals } from './useArchivedProposals';
export const useArchivedProposalActions = ()=>{
    const worksAt = useStore(selectors.user.business);
    const { t: archivedTexts } = useLocaleKeys('proposal.archivedDashboard.actions');
    const { contactsMap, sampleContact } = useContactsMap(worksAt === null || worksAt === void 0 ? void 0 : worksAt.id);
    const { refresh } = useArchivedProposals();
    const { showConfirmAction } = useOverlayContext();
    const navigate = useNavigate();
    const { duplicateDraft } = useDuplicateDraft({
        onSuccess: (newDraftId)=>navigate("/draft/".concat(newDraftId)),
        biCode: 18803
    });
    const { previewDraft } = usePreviewDraft({
        sampleContact,
        contactsMap
    });
    const { terminateDraftById } = useTerminateAgreement();
    const confirmEdit = (draftId, unarchiveDraft)=>showConfirmAction({
            biName: 'edit_archived_proposal_confirm',
            onConfirm: ()=>unarchiveDraft(draftId),
            title: archivedTexts.editArchived(),
            content: archivedTexts.editModalContent(),
            primaryButtonLabel: archivedTexts.continueButton(),
            secondaryButtonLabel: archivedTexts.cancelButton()
        });
    const confirmDuplicate = (draftId)=>showConfirmAction({
            biName: 'duplicate_archived_proposal_confirm',
            onConfirm: ()=>duplicateDraft(draftId),
            title: archivedTexts.duplicateArchived(),
            content: archivedTexts.duplicateModalContent(),
            primaryButtonLabel: archivedTexts.continueButton(),
            secondaryButtonLabel: archivedTexts.cancelButton()
        });
    return (param)=>{
        let { draftId, unarchiveDraft } = param;
        return [
            {
                icon: Eye,
                label: archivedTexts.preview(),
                onClick: ()=>previewDraft(draftId),
                bi: {
                    name: 'preview',
                    data: {
                        draftId
                    }
                }
            },
            {
                icon: Edit,
                label: archivedTexts.edit(),
                onClick: ()=>confirmEdit(draftId, unarchiveDraft),
                bi: {
                    name: 'edit',
                    data: {
                        draftId
                    }
                }
            },
            {
                icon: Copy,
                label: archivedTexts.duplicate(),
                onClick: ()=>confirmDuplicate(draftId),
                bi: {
                    name: 'duplicate',
                    data: {
                        draftId
                    }
                }
            },
            {
                icon: Trash,
                label: archivedTexts.delete(),
                onClick: (biCallerContext)=>terminateDraftById(draftId, ()=>refresh(), biCallerContext),
                bi: {
                    name: 'delete',
                    data: {
                        draftId
                    }
                },
                destructive: true
            }
        ];
    };
};
